import { assertNever } from "assert-never";

import { LineCol, SrcSpan } from "./gen/SrcLoc";

export function srcSpanContains(srcSpan: SrcSpan, lineCol: LineCol): boolean {
  switch (srcSpan.kind) {
    case "line":
      return lineCol.line === srcSpan.value;
    case "lineCol":
      return lineCol.line === srcSpan.value.line && lineCol.col === srcSpan.value.col;
    case "lineRange":
      return lineCol.line >= srcSpan.value.startLine && lineCol.line <= srcSpan.value.endLine;
    case "lineColRange":
      if (
        lineCol.line >= srcSpan.value.start.line + 1 &&
        lineCol.line <= srcSpan.value.end.line - 1
      ) {
        return true;
      } else if (srcSpan.value.start.line === srcSpan.value.end.line) {
        return (
          lineCol.line === srcSpan.value.start.line &&
          lineCol.col >= srcSpan.value.start.col &&
          lineCol.col <= srcSpan.value.end.col
        );
      } else if (lineCol.line === srcSpan.value.start.line) {
        return lineCol.col >= srcSpan.value.start.col;
      } else if (lineCol.line === srcSpan.value.end.line) {
        return lineCol.col <= srcSpan.value.end.col;
      } else {
        return false;
      }
    default:
      return assertNever(srcSpan);
  }
}
